// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2u-Vg","container":"Footer_container__3QjZw","links":"Footer_links__O0mF2","copyright":"Footer_copyright__2m80d","attribution":"Footer_attribution__aMdec"};